import React from "react";
import Navigation from "./Navigation";
import Drawer from "./Drawer";


function Header(props) {
  React.useEffect(() => {
    const sub = props.userSub;
    if (!sub || typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    try {
      const mid = process.env.REACT_APP_GA_MEASUREMENT_ID;
      if (mid) {
        window.gtag('config', mid, { user_id: props.user.attributes.email });
      } else {
        window.gtag('set', { user_id: props.user.attributes.email });
      }
      window.gtag('set', 'user_properties', { auth_provider: 'Cognito' });
      window.gtag('set', 'user_properties', { gtag_email: props.user.attributes.email });

      window.gtag('event', 'login', { method: 'Cognito' });
    } catch (_e) {}
  }, [props.userSub]);
  return (
    <header className="border-b	 p-3 flex justify-between items-center">
      <Navigation user={props.user} signOut={props.signOut}/>
    </header>
  );
}

export default Header;
